import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import {
  Navigate,
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes,
  useNavigate,
} from "react-router-dom";
import CreateHymn from "./pages/CreateHymn";
import Dashboard from "./pages/Dashboard";
import EditHymn from "./pages/EditHymn";
import HymnsPage from "./pages/Hymns";
import Login from "./pages/Login";
import "./styles/index.scss";
import Overview from "./pages/Overview";
import SingleHymn from "./pages/SingleHymn";
import SignaturesPage from "./pages/Signatures";

function RedirectWhereNeeded() {
  const token = localStorage.getItem("t");
  if (!token) {
    return <Navigate to="/login" />;
  } else {
    return <Navigate to="/d" />;
  }
}
function App() {
  return (
    <MantineProvider>
      <Notifications />
      <ModalsProvider>
        <Router>
          <Routes>
            <Route path="/" element={<RedirectWhereNeeded />} />
            <Route path="/login" element={<Login />} />
            <Route path="/d" element={<Dashboard />}>
              <Route index path="/d" element={<Overview />} />
              <Route path="/d/hymns" element={<HymnsPage />} />
              <Route path="/d/create-hymn" element={<CreateHymn />} />
              <Route path="/d/hymn/:hymnID" element={<SingleHymn />} />
              <Route path="/d/hymns/:hymnID/edit" element={<EditHymn />} />
              <Route path="/d/signatures" element={<SignaturesPage />} />
            </Route>
          </Routes>
        </Router>
      </ModalsProvider>
    </MantineProvider>
  );
}

export default App;
